/**
 * Route for `customer-io-integration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CustomerIoIntegrationPage } from "../features/customer-io-integration/CustomerIoIntegrationPage";

export const customerIoIntegrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/customer-io-integration",
	component: CustomerIoIntegrationPage,
});

export default customerIoIntegrationRoute;
